export default {"src":"/_next/static/media/upi.2c94fbc3.svg","height":71,"width":140,"blurWidth":0,"blurHeight":0};